import { jsx } from "react/jsx-runtime";
import React from "react";
import { string, oneOf } from "prop-types";
import cx from "classnames";
const propTypes = {
  /** Prefix all classes in every element with this string */
  prefix: string,
  /** Additional component classes */
  className: string,
  /** Sets size of `LoadingBall`. One of [`'small'`, `'medium'`, `'large'`] */
  size: oneOf(["small", "medium", "large"]),
  /** Sets color of `LoadingBall`. One of [`'emphasised'`, `'primary'`, `'secondary'`] */
  color: oneOf(["emphasised", "primary", "secondary"])
};
const LoadingBall = (props) => {
  const {
    className,
    prefix = "",
    size = "large",
    color = "emphasised",
    ...otherProps
  } = props;
  const baseClass = `${prefix}loading__ball`;
  const loadingBallClass = cx(
    baseClass,
    `${baseClass}--${size}`,
    `${baseClass}--${color}`
  );
  return /* @__PURE__ */ jsx("span", { ...otherProps, className: loadingBallClass, "aria-hidden": true });
};
LoadingBall.propTypes = propTypes;
var LoadingBall_default = LoadingBall;
export {
  LoadingBall_default as default
};
